import client from '@/config/directus.api';
import { isInteger, isObject } from 'lodash';

const COLLECTION = 'companies';

export class Company {
  constructor(payload) {
    this.id = payload.id;
    this.city = payload.city;
    this.email = payload.email;
    this.fax = payload.fax;
    this.name = payload.name;
    this.phone = payload.phone;
    this.slogan = payload.slogan;
    this.street_nr = payload.street_nr;
    this.web = payload.web;
    this.zip = payload.zip;

    // Update relations
    if (payload.hasOwnProperty('country') && isObject(payload.country) && payload.country.hasOwnProperty('id')) {
      this.country = { id: payload.country.id };
    } else if (isInteger(payload.country)) {
      this.country = { id: payload.country };
    } else if (!payload.country) {
      this.country = { id: null };
    }

    if (payload.hasOwnProperty('logo') && isObject(payload.logo) && payload.logo.hasOwnProperty('id')) {
      this.logo = { id: payload.logo.id };
    } else if (isInteger(payload.logo)) {
      this.logo = { id: payload.logo };
    } else if (!payload.logo) {
      this.logo = { id: null };
    }

    if (payload.hasOwnProperty('logo_black') && isObject(payload.logo_black) && payload.logo_black.hasOwnProperty('id')) {
      this.logo_black = { id: payload.logo_black.id };
    } else if (isInteger(payload.logo_black)) {
      this.logo_black = { id: payload.logo_black };
    } else if (!payload.logo_black) {
      this.logo_black = { id: null };
    }

    if (payload.hasOwnProperty('logo_white') && isObject(payload.logo_white) && payload.logo_white.hasOwnProperty('id')) {
      this.logo_white = { id: payload.logo_white.id };
    } else if (isInteger(payload.logo_white)) {
      this.logo_white = { id: payload.logo_white };
    } else if (!payload.logo_white) {
      this.logo_white = { id: null };
    }
  }
}

/**
 * Get company by id
 * @param {int} id
 * @return {promise}
 */
export function getCompanyById(id) {
  return client
    .getItems(COLLECTION, {
      filter: {
        id
      }
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get companies
 */
export function getCompanies() {
  return client
    .getItems(COLLECTION, {})
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get company data for current user
 *
 * @return {promise}
 */
export function getMyCompany() {
  return client
    .get('custom/companies/my')
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Update company by id
 * @param {int} id
 * @param {object} payload
 * @return {promise}
 */
export function updateCompanyById(id, payload) {
  const company = new Company(payload);
  return client
    .updateItem(COLLECTION, id, company)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get long live access token from facebook
 *
 * @param   {Integer}  companyId
 * @param   {String}  accessToken
 *
 * @return  {void}
 */
export function getFBLongLiveAccessToken(companyId, accessToken) {
  return client
    .get(`custom/companies/${companyId}/fbAccessToken?access_token=${accessToken}`)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Get page access token from facebook
 *
 * @param   {Integer}  pageId
 * @param   {String}  accessToken
 *
 * @return  {Promise}
 */
export function getFbPageAccessToken(pageId, accessToken) {
  return client
    .get(`custom/companies/fbPageAccessToken?page_id=${pageId}&access_token=${accessToken}`)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
